import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

import { SubscriptionStatus } from '@utils/interfaces';

export interface User {
  billingAmountCBPT?: number;
  cbptTaxAmountExclusive?: number;
  cbptTotalWithTax?: number;
  dobVerified?: boolean;
  email?: string;
  id?: number;
  isDueInFuture?: boolean;
  isYPEligible?: boolean;
  name?: string;
  nextBillingDate?: string;
  // Lets a logged-out prefilled checkout (/subscribe?email=) create a paid subscription
  prefillToken?: string;
  stripeCustomerId?: string;
  subscriptionStatus?: SubscriptionStatus;
}

type UserWithChildren = { children: ReactNode; user: User };

const SubscribeFormContext = createContext<{
  user: User;
  setUser: Dispatch<SetStateAction<User>>;
}>({
  user: {
    dobVerified: false,
    email: '',
    id: null,
    isYPEligible: false,
    name: '',
    stripeCustomerId: '',
    subscriptionStatus: null,
  },
  setUser: () => undefined,
});

export const SubscribeFormProvider = ({
  children,
  user: {
    billingAmountCBPT,
    cbptTaxAmountExclusive,
    cbptTotalWithTax,
    dobVerified,
    email,
    id,
    isDueInFuture,
    isYPEligible,
    name,
    nextBillingDate,
    prefillToken,
    stripeCustomerId,
    subscriptionStatus,
  },
}: UserWithChildren) => {
  const [user, setUser] = useState<User>({
    billingAmountCBPT,
    cbptTaxAmountExclusive,
    cbptTotalWithTax,
    dobVerified,
    email,
    id,
    isDueInFuture,
    isYPEligible,
    name,
    nextBillingDate,
    prefillToken,
    stripeCustomerId,
    subscriptionStatus,
  });

  return (
    <SubscribeFormContext.Provider value={{ user, setUser }}>
      {children}
    </SubscribeFormContext.Provider>
  );
};

export const useSubscribeForm = () => {
  const context = useContext(SubscribeFormContext);
  return context;
};
